import { User } from '@/features/auth/types/auth.types';

/**
 * Priority-ordered list of chatbot-builder sub-routes.
 * Uses permission KEY strings (e.g. 'flow_builder.view') which are matched
 * directly against the `permissionKeys` array from the backend auth response.
 * No frontend code mapping needed.
 */
// const BUILDER_ROUTE_PRIORITY: { subPath: string; permission: string }[] = [
//     { subPath: 'whatsapp/dashboard', permission: 'whatsapp_connection.view' },
//     { subPath: 'live-chat', permission: 'live_chat.view' },
//     { subPath: 'whatsapp/workflows/flow-builder', permission: 'flow_builder.view' },
//     { subPath: 'whatsapp/workflows/flow-builder', permission: 'flow_builder.create' },
//     { subPath: 'whatsapp/workflows', permission: 'workflow.view' },
//     { subPath: 'whatsapp/workflows/api-management', permission: 'workflow_api_management.view' },
//     { subPath: 'whatsapp/campaigns', permission: 'whatsapp_campaign.view' },
//     { subPath: 'whatsapp/templates', permission: 'whatsapp_templates.view' },
//     { subPath: 'whatsapp/contacts', permission: 'contacts.view' },
//     { subPath: 'whatsapp/attributes', permission: 'attribute.view' },
//     { subPath: 'training', permission: 'training_content.view' },
//     { subPath: 'basic-info', permission: 'chatbots.view' },
//     { subPath: 'team', permission: 'team_management.view' },
//     { subPath: 'roles', permission: 'team_management.view' },
//     { subPath: 'settings', permission: 'settings.view' },
//     { subPath: 'payment-history', permission: 'subscription.view' },
//     { subPath: 'whatsapp/api-keys', permission: 'api_integration_key.view' },
// ];

/**
 * Returns the best default route after login.
 *
 * - Admins and super-admins → chatbot builder at whatsapp/dashboard.
 * - Staff users → first chatbot-builder sub-route they have permission for.
 * - Falls back to '/' if no chatbotId or no matching permission.
 *
 * Uses `permissionKeys` (string[]) from the auth response directly —
 * no frontend numeric code lookup needed.
 */
export function getDefaultRouteForUser(user: User | null): string {
    
    if (!user) return '/login';

    const chatbotId = user.user.chatbotId;

    // Owners and super-admins always land on the chatbot builder's WhatsApp connection page
        return chatbotId
            ? `/chatbot-builder/${chatbotId}/whatsapp/dashboard`
            : '/';

    // Staff: walk through priority list using string key matching
    // if (chatbotId) {
    //     for (const { subPath, permission } of BUILDER_ROUTE_PRIORITY) {
    //         if (permissionKeys.includes(permission)) {
    //             return `/chatbot-builder/${chatbotId}/${subPath}`;
    //         }
    //     }
    // }

    // Absolute fallback
    return '/';
}
